import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";

import { commonToast } from "../../Utils";
import {
  isValidEmail,
  LoadingButton,
  SpinnerBlock,
} from "../../Utils/CustomComponent";

// import slsLogo from "../../assets/images/loanlinq.png";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import urls from "../../Utils/urls";
import {
  loadingTypes,
  oracleConfig,
  thirdPartyPayoffArr,
} from "../../Utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchUSStates } from "../../store/reducers/dashboardSlice/api";
import PopupWrapper from "../../components/PopupWrapper";
import {
  Building,
  CheckCircleFill,
  ChevronLeft,
  ClipboardCheck,
  CreditCard,
  ExclamationTriangle,
  ExclamationTriangleFill,
  FileEarmarkText,
  House,
  InfoCircle,
  Person,
  QuestionCircleFill,
  Search,
  Send,
  XCircleFill,
} from "react-bootstrap-icons";
import { Button } from "../../components/Button";
import {
  Card,
  Form,
  InputGroup,
  Button as ImportedButton,
  Alert,
  Spinner,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import ".././VerificationForm/VerificationForm.css";
// import UseSignature from "../../components/FormBox/UseSignature";
import UseFormFileInput from "../../components/FormBox/UseFormFileInput";
import ReviewInformation, {
  ReviewInformationForPayoff,
} from ".././VerificationForm/ReviewInformation";
// import PaymentStep from "./PaymentStep";
import PropertyAddressModal from ".././VerificationForm/PropertyAddressModal";
import axiosInstance from "../../axios";
import { thirdPartyPayoffSchema } from "../../Utils/formOptions";
import { VOMNavbar } from "../VerificationForm";

const steps = [
  { title: "Requestor Details", sub: "Your information" },
  { title: "Property", sub: "Property address" },
  { title: "Applicant", sub: "Borrower's Authorization" },
  { title: "Review", sub: "Confirm details" },
  //   { title: "Payment", sub: "Choose payment" },
];

const stepsForBorrower = [
  { title: "Requestor Details", sub: "Your information" },
  { title: "Property", sub: "Property address" },
];

const headers = {
  "x-api-key": "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJ",
};

const US_Holidays = [
  {
    date: new Date("01/01/2026"),
    holidayName: "New Year's Day",
  },
  {
    date: new Date("01/19/2026"),
    holidayName: "Martin Luther King Jr. Day",
  },
  {
    date: new Date("02/16/2026"),
    holidayName: "Presidents' Day",
  },
  {
    date: new Date("05/23/2026"),
    holidayName: "Memorial Day",
  },
  {
    date: new Date("06/19/2026"),
    holidayName: "Juneteenth",
  },
  {
    date: new Date("07/04/2026"),
    holidayName: "Independence Day",
  },
  {
    date: new Date("09/07/2026"),
    holidayName: "Labor Day",
  },
  {
    date: new Date("10/12/2026"),
    holidayName: "Columbus Day",
  },
  {
    date: new Date("11/11/2026"),
    holidayName: "Veterans Day",
  },
  {
    date: new Date("11/26/2026"),
    holidayName: "Thanksgiving Day",
  },
  {
    date: new Date("12/25/2026"),
    holidayName: "Christmas Day",
  },
];

const PayoffRequestForm = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showInvalidModal, setShowInvalidModal] = useState(false);
  const [invalidModalMessage, setInvalidModalMessage] = useState("");
  const [step, setStep] = useState(0);
  const [loanNumberLoading, setLoanNumberLoading] = useState(false);
  const [loanNumberStatus, setLoanNumberStatus] = useState(null);
  const [isValidAccount, setIsValidAccount] = useState(false);
  // const [method, setMethod] = useState(null);
  // const [submitFlag, setSubmitFlag] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showPropertySearch, setShowPropertySearch] = useState(false);
  const [noPropertyFound, setNoPropertyFound] = useState(false);
  const [validLoanNumber, setValidLoanNumber] = useState(null);
  const [limitReached, setLimitReached] = useState(false);
  // const [checkingLimit, setCheckingLimit] = useState(true);
  const [loanStatus, setLoanStatus] = useState(null);
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [validBorrower, setValidBorrower] = useState(false);
  const [validLender, setValidLender] = useState(false);
  const [loanRecid, setLoanRecid] = useState(null);

  const states = useSelector((state) => state.dashboard.USstates.data);
  const status = useSelector((state) => state.dashboard.USstates.status);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const alertRef = useRef(null);
  const email = localStorage.getItem("email_for_payoff");

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    trigger,
    setError,
    clearErrors,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(thirdPartyPayoffSchema(isValidAccount)),
    defaultValues: {
      requesting_date: new Date(),
      borrower_sign_available: false,
      masked_applicant_name: "",
      property_street: "",
      requestor_email: email,
      cema: "N",
    },
  });

  const display = watch("borrower_sign_available");
  const borrowerSignature = watch("borrower_signature");
  const knows_loan_account = watch("knows_loan_account");
  const borrower_email = watch("borrower_email");
  const remarks = watch("remarks");
  const property_street = watch("property_street");
  const property_city = watch("property_city");
  const property_state = watch("property_state");
  const property_zip = watch("property_zip");
  const propertyAddress = `${property_street} ${property_city}, ${property_state} ${property_zip}`;
  const dataForCheckingDuplicate = watch();
  const payoff_good_through_date = watch("payoff_good_through_date");
  const accountNumber = watch("account_number");
  const requestor_email = watch("requestor_email");
  const requestor_type = watch("requestor_type");
  const cema = watch("cema");
  const demand_expiration_date = watch("demand_expiration_date");
  const requesting_date = watch("requesting_date");

  const requestDate = new Date();

  //   useEffect(() => {
  //     const checkLimit = async () => {
  //       try {
  //         const res = await axios.get(urls.VOM.VOMCount(email), oracleConfig);
  //         // console.log(res?.data?.items?.[0]?.no_of_vom_created);

  //         if (res?.data?.items?.[0]?.no_of_vom_created >= 5) {
  //           setLimitReached(true);
  //         }
  //       } catch (error) {
  //         console.error(error);
  //       } finally {
  //         setCheckingLimit(false);
  //       }
  //     };

  //     checkLimit();
  //   }, []);

  useEffect(() => {
    async function getCurrentDate() {
      try {
        const res = await axiosInstance.get(urls.borrower.currentDateNTime, {
          headers: { "x-api-key": "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJ" },
        });
        setMinDate(res?.data?.datetime);

        const maxAllowedDate = new Date(res?.data?.datetime);
        maxAllowedDate.setDate(maxAllowedDate.getDate() + 30);

        setMaxDate(maxAllowedDate);
      } catch (error) {
        console.error(error);
      }
    }

    getCurrentDate();
  }, []);

  // useEffect(() => {
  //   if (loanStatus === "Paid off") {
  //     setMethod("stripe");
  //   }
  // }, [loanStatus]);

  useEffect(() => {
    if (status === loadingTypes.idle) {
      dispatch(fetchUSStates());
    }
  }, [dispatch, status]);

  const demandExpirationDate = useMemo(() => {
    return payoff_good_through_date
      ? new Date(moment(payoff_good_through_date).add(7, "days"))
      : null;
  }, [payoff_good_through_date]);

  useEffect(() => {
    setValue("demand_expiration_date", demandExpirationDate);
  }, [demandExpirationDate]);

  // useEffect(() => {
  //   if (step === 1 && knows_loan_account === "N") {
  //     window.open(
  //       "https://support.loanlinq.com/ords/f?p=134",
  //       "_blank",
  //       "noopener,noreferrer"
  //     );
  //   }
  // }, [knows_loan_account, step]);

  //   if (!email || !isValidEmail(email)) {
  //     return <Navigate to="unauthorized" replace />;
  //   }

  const scrollToAlert = () => {
    alertRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const next = async () => {
    // const fieldsToValidate
    // const isValid = await trigger();
    // if (!isValid) return;
    if (step === 0 && accountNumber && requestor_type) {
      validateLoanAccount();
    }
    if (step === 1) {
      await checkForDuplicate();
    }

    const valid = await trigger(
      thirdPartyPayoffArr?.[step]?.arr?.map((f) => f.field),
    );
    if (valid) setStep((s) => s + 1);
    else if (step === 1 && !valid) {
      scrollToAlert();
    }
  };

  const back = () => setStep((s) => Math.max(s - 1, 0));

  const onSubmit = async (data) => {
    setSubmitLoading(true);
    const id = toast.loading("Submitting Payoff request...");
    try {
      const trimmedData = Object.fromEntries(
        Object.entries(data).map(([k, v]) => [
          k,
          typeof v === "string" ? v.trim() : v,
        ]),
      );

      const payload = {
        ...trimmedData,
        requesting_date: moment(trimmedData.requesting_date).format(
          "MM/DD/YYYY",
        ),
        payoff_good_through_date: moment(
          trimmedData.payoff_good_through_date,
        ).format("MM/DD/YYYY"),
        demand_expiration_date: moment(
          trimmedData.demand_expiration_date,
        ).format("MM/DD/YYYY"),
        borrower_sign_available: trimmedData?.borrower_sign_available
          ? "Y"
          : "N",
        logger_email: requestor_email,
      };

      const res = await axios.post(
        urls.payOffDemand.createThirdPartyPayoff,
        payload,
        oracleConfig,
      );

      if (res?.data?.status === "success") {
        if (trimmedData?.borrower_sign_available) {
          const sanitizedFileName = borrowerSignature.name.replace(/ /g, "_");

          const formData = new FormData();
          formData.append("document", borrowerSignature, sanitizedFileName);
          formData.append("request_id", res?.data?.request_id);

          const bucketResponse = await axiosInstance.post(
            urls.payOffDemand.uploadBorrowerAuth,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            },
          );

          if (bucketResponse?.status == 200) {
            const authPayload = {
              request_id: bucketResponse?.data?.request_id,
              filename: bucketResponse?.data?.filename,
              file_mimetype: bucketResponse?.data?.file_mimetype,
              url: bucketResponse?.data?.url,
              created_by: email,
              tag: "BORROWER_AUTH",
              logger_email: email,
            };
            const finalApiRes = await axiosInstance.post(
              urls.payOffDemand.updateAuthInfo,
              authPayload,
              oracleConfig,
            );

            if (finalApiRes?.status == 200) {
              toast.update(id, {
                render: "Payoff request submitted successfully",
                type: "success",
                isLoading: false,
                ...commonToast,
              });

              navigate("/thankyou", {
                state: {
                  text: "Your payoff request has been successfully submitted.",
                  showBtn: false,
                },
              });
            }
          }
        } else {
          toast.update(id, {
            render: "Payoff request submitted successfully",
            type: "success",
            isLoading: false,
            ...commonToast,
          });

          navigate("/thankyou", {
            state: {
              text: "Your payoff request has been successfully submitted.",
              showBtn: false,
            },
          });
        }
      }

      toast.update(id, {
        render: "Payoff request submitted successfully",
        type: "success",
        isLoading: false,
        ...commonToast,
      });

      navigate("/thankyou", {
        state: {
          text: "Your payoff request has been successfully submitted.",
          showBtn: false,
        },
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.update(id, {
        render: "Submission Failed. Please try again.",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const maskStreetSmart = (street) => {
    if (!street) return "";

    return street
      .split(" ")
      .map((word) => {
        const len = word.length;
        const half = Math.floor(len / 2);

        return word.substring(0, len - half) + "*".repeat(half);
      })
      .join(" ");
  };

  // const handleFlag = () => {
  //   setSubmitFlag(true);
  // };

  const validateLoanAccount = async () => {
    if (!accountNumber) {
      setError("account_number", {
        type: "manual",
        message: "Loan account number is required",
      });
      return;
    }

    try {
      setLoanNumberLoading(true);

      const res = await axios.get(
        urls.VOM.validateLoanNumber(accountNumber),
        oracleConfig,
      );

      if (res.data?.status === "success") {
        if (res.data?.loan_status === "Paid off") {
          setError("account_number", {
            type: "manual",
            message:
              "This loan has been paid off. Please enter an active loan number.",
          });
        } else {
          if (requestor_type === "Borrower") {
            await validateBorrower(res?.data?.loanrecid, accountNumber);
          } else if (requestor_type === "Lender") {
            await validateLender(res?.data?.loanrecid, accountNumber);
          } else {
            setValidBorrower(false);
            setValidLender(false);
          }
          const data = res?.data?.primary_property;
          clearErrors("account_number");
          // ✅ mark as validated
          setIsValidAccount(true);
          setValidLoanNumber(res?.data?.account);
          // setValue("applicant_name", res?.data?.["borrower name"]);
          // setValue("borrower_mailing_address", res?.data?.["mailing_address"]);
          setValue(
            "masked_applicant_name",
            maskStreetSmart(res?.data?.["borrower name"]),
          );
          setValue("masked_property_street", maskStreetSmart(data?.street));
          setValue("property_street", data?.street);
          setValue("property_city", data?.city);
          setValue("property_state", data?.state);
          setValue("property_zip", data?.zipcode);

          setLoanStatus(res?.data?.loan_status);
          setLoanNumberStatus("success");
        }
      } else {
        setLoanStatus(null);
        setValidLoanNumber(null);
        throw new Error();
      }
    } catch (err) {
      if (
        err?.response?.request?.responseURL ===
        urls.payOffDemand.validateBorrower
      ) {
        setIsValidAccount(false);
        setValidLoanNumber(null);
        setLoanNumberStatus("error");
        setLoanStatus(null);

        setError("account_number", {
          type: "manual",
          message:
            "The email address you entered does not match the email address registered to this loan.",
        });
        setValue("property_street", "");
        setValue("property_city", "");
        setValue("property_state", "");
        setValue("property_zip", "");
      } else {
        setIsValidAccount(false);
        setValidLoanNumber(null);
        setLoanNumberStatus("error");
        setLoanStatus(null);

        setError("account_number", {
          type: "manual",
          message: "Invalid loan account number",
        });
        setValue("property_street", "");
        setValue("property_city", "");
        setValue("property_state", "");
        setValue("property_zip", "");
        // setValue("applicant_name", "");
        // setValue("borrower_mailing_address", "");
      }
    } finally {
      setLoanNumberLoading(false);
    }
  };

  async function validateBorrower(loanrecid, loan_number, source = "loan") {
    try {
      const payloadForValidation = {
        loan_number: loan_number,
        requestor_email: requestor_email,
      };
      // API for validating requestor_email against loan number
      const res2 = await axios.post(
        urls.payOffDemand.validateBorrower,
        payloadForValidation,
        oracleConfig,
      );

      if (res2.data.response === "True") {
        setValidBorrower(true);
        setValidLender(false);
        setLoanRecid(loanrecid);
      }
    } catch (error) {
      console.error(error);
      setValidBorrower(false);
      setValidLender(false);
      setLoanRecid(null);
      // if (source === "property") {
      //   navigate("/payoff/invalid");
      // }
      setInvalidModalMessage(
        "The email address associated with this loan does not match the email address entered. Would you like to proceed as a third-party requester for this loan payoff?",
      );
      setShowInvalidModal(true);
    }
  }

  async function validateLender(loanrecid, loan_number, source = "loan") {
    try {
      const payloadForValidation = {
        loan_number: loan_number,
        requestor_email: requestor_email,
      };
      // API for validating requestor_email against loan number
      const res2 = await axios.post(
        urls.payOffDemand.validateLender,
        payloadForValidation,
        oracleConfig,
      );

      if (res2.data.response === "True") {
        setValidLender(true);
        setValidBorrower(false);
        setLoanRecid(loanrecid);
      }
    } catch (error) {
      console.error(error);
      setValidBorrower(false);
      setValidLender(false);
      setLoanRecid(null);
      // if (source === "property") {
      //   navigate("/payoff/invalid");
      // }
      setInvalidModalMessage(
        "The email address associated with this loan does not match the email address entered. Would you like to proceed as a third-party requester for this loan payoff?",
      );
      setShowInvalidModal(true);
    }
  }

  async function createPayoffDirectly(party = "Borrower") {
    const id = toast.loading("Submitting Payoff request...");
    try {
      setSubmitLoading(true);

      const payload = {
        loanrecid: loanRecid,
        loan_number: accountNumber,
        payoff_good_through_date: moment(payoff_good_through_date).format(
          "MM/DD/YYYY",
        ),
        demand_expiration_date: moment(demand_expiration_date).format(
          "MM/DD/YYYY",
        ),
        requesting_party_email: requestor_email,
        source:
          party === "Borrower"
            ? "Third Party - Borrower"
            : party === "Lender" && "Third Party - Lender",
        payoff_requested_date: moment(requesting_date).format("MM/DD/YYYY"),
        remarks: "",
        role: party,
        logger_email: email,
      };

      const res = await axios.post(
        urls.support.createPayoff,
        payload,
        oracleConfig,
      );

      if (res.status == 200) {
        toast.update(id, {
          render: "Payoff request submitted successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });

        navigate("/thankyou", {
          state: {
            text: "Your payoff request has been successfully submitted.",
            showBtn: false,
          },
        });
      }
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "Submission Failed. Please try again.",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setSubmitLoading(false);
    }
  }

  async function checkForDuplicate() {
    try {
      setSubmitLoading(true);
      const res = await axios.post(
        urls.payOffDemand.checkDuplicatePayoff,
        {
          account_number: accountNumber,
        },
        oracleConfig,
      );
      // console.log(res, "res");
      if (res?.data?.Message === "Duplicate Record Exist.") {
        navigate(`/payoff/duplicate`);
      } else {
        if (validBorrower) {
          await createPayoffDirectly("Borrower");
        } else if (validLender) {
          await createPayoffDirectly("Lender");
        }
        setSubmitLoading(false);
        return 1;
      }
    } catch (error) {
      toast.error("Some error occured. Please try again");
      console.error(error);
    } finally {
      setSubmitLoading(false);
    }
  }

  const isWeekdayAndNotHoliday = (date) => {
    const day = date.getDay();
    const holidays = US_Holidays.map((holiday) => holiday.date.toDateString());

    return day !== 0 && day !== 6 && !holidays.includes(date.toDateString());
  };

  // if (checkingLimit) {
  //   return (
  //     <div style={{ marginTop: "130px" }}>
  //       <SpinnerBlock height="50vh" />
  //     </div>
  //   );
  // }

  return (
    <div className="bg-light min-vh-100" style={{ backgroundColor: "#F8FBFF" }}>
      {/* FIXED TOP NAVBAR */}
      <VOMNavbar title="Request Payoff" />

      <div className="vf-header-wrapper" style={{ paddingTop: "5rem" }}>
        {/* {limitReached && (
          <div className="d-flex justify-content-center align-items-center">
            <div className="alert alert-info text-center w-75 fw-bold">
              You have reached your daily limit of 5 VOM requests.
            </div>
          </div>
        )} */}
        {/* <div className="vf-header text-center" style={{ paddingTop: "7rem" }}> */}
        {/* <div className="vf-doc-pill">
          <FileEarmarkText size={16} />
          <span>Official Document</span>
        </div> */}

        <h1 className="vf-title">Request for Payoff</h1>

        <p className="vf-subtitle">
          Complete the form below to submit your payoff request.
          <br />
          All information is securely transmitted and protected.
        </p>
        {/* </div> */}
      </div>

      {/* Content */}
      <div className="vf-page">
        {/* ===== STEPPER ===== */}
        {!validBorrower && !validLender && (
          <div className="vf-stepper">
            {steps.map((s, i) => (
              <div key={i} className="vf-step-wrapper">
                <div
                  className={`vf-step-circle ${
                    i < step ? "done" : i === step ? "active" : ""
                  }`}
                >
                  {i < step ? "✓" : i + 1}
                </div>
                <div className="vf-step-text">
                  <div className="vf-step-title">{s.title}</div>
                  <div className="vf-step-sub">{s.sub}</div>
                </div>
                {i < steps.length - 1 && <div className="vf-step-line" />}
              </div>
            ))}
          </div>
        )}
        {(validBorrower || validLender) && (
          <div className="vf-stepper">
            {stepsForBorrower.map((s, i) => (
              <div key={i} className="vf-step-wrapper">
                <div
                  className={`vf-step-circle ${
                    i < step ? "done" : i === step ? "active" : ""
                  }`}
                >
                  {i < step ? "✓" : i + 1}
                </div>
                <div className="vf-step-text">
                  <div className="vf-step-title">{s.title}</div>
                  <div className="vf-step-sub">{s.sub}</div>
                </div>
                {i < stepsForBorrower.length - 1 && (
                  <div className="vf-step-line" />
                )}
              </div>
            ))}
          </div>
        )}

        {/* ===== CARD ===== */}
        <Card className="vf-card">
          {/* HEADER */}
          <div className="vf-card-header text-start">
            <div className="vf-icon">
              {step === 0 && <Building size={25} />}
              {step === 1 && <House size={25} />}
              {step === 2 && <Person size={25} />}
              {step === 3 && <ClipboardCheck size={25} />}
              {/* {step === 4 && <CreditCard size={25} />} */}
            </div>
            <div>
              <div className="vf-header-title">{steps[step].title}</div>
              <div className="vf-header-sub">
                {validBorrower || validLender
                  ? `Step ${step + 1} of 2`
                  : `Step ${step + 1} of 4`}
              </div>
            </div>
          </div>

          {/* BODY */}
          <div className="vf-card-body">
            {/* STEP 1 STATIC TO BOX */}
            <form
              style={{
                pointerEvents: limitReached ? "none" : "auto",
                opacity: limitReached ? 0.5 : 1,
              }}
            >
              <div
                style={{
                  maxHeight: "26rem",
                  // overflowY: "auto",
                  // overflowX: "hidden",
                }}
              >
                {step === 0 && (
                  <div className="row text-start">
                    <div className="vf-group-for-payoff col-6">
                      <SelectField
                        label={"Requestor Type (Title)"}
                        field={"requestor_type"}
                        placeholder={"Select..."}
                        options={[
                          { label: "Lender", value: "Lender" },
                          // { label: "Broker", value: "Broker" },
                          { label: "Borrower", value: "Borrower" },
                          { label: "Other / Third-Party", value: "Other" },
                        ]}
                        watch={watch}
                        setValue={setValue}
                        control={control}
                        required={true}
                      />
                      {errors.requestor_type && (
                        <small className="text-error mt-5">
                          {errors.requestor_type.message}
                        </small>
                      )}
                    </div>

                    <div className="vf-group-for-payoff col-6">
                      <label>
                        Requestor Name <span className="text-danger">*</span>
                      </label>
                      <input
                        {...register("requestor_name")}
                        className={
                          errors.requestor_name ? "vf-input error" : "vf-input"
                        }
                        placeholder="Enter requestor name"
                      />
                      {errors.requestor_name && (
                        <small className="text-error">
                          {errors.requestor_name.message}
                        </small>
                      )}
                    </div>

                    <div className="vf-group-for-payoff col-6">
                      <label>
                        Requestor Email{" "}
                        <span
                          className="text-muted"
                          data-bs-toggle="tooltip"
                          title="The payoff statement will be delivered to this email address."
                        >
                          <QuestionCircleFill className="mb-2" />
                        </span>
                      </label>
                      <input
                        {...register("requestor_email")}
                        className={"vf-input"}
                        disabled
                        // placeholder="Enter requestor address"
                      />
                    </div>

                    <div className="vf-group-for-payoff col-6">
                      <label>Phone Number (Optional)</label>
                      <input
                        {...register("phone_number")}
                        className={
                          errors.phone_number ? "vf-input error" : "vf-input"
                        }
                        // value={watch("lender_number")}
                        onChange={(e) =>
                          setValue(
                            "phone_number",
                            formatPhoneNumber(e.target.value),
                          )
                        }
                        placeholder="Ex: (123) 456-7890"
                      />
                      {errors.phone_number && (
                        <small className="text-error">
                          {errors.phone_number.message}
                        </small>
                      )}
                    </div>

                    <div className="vf-group-for-payoff col-6">
                      <label>
                        Payoff Good Through Date{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Controller
                        name="payoff_good_through_date"
                        control={control}
                        render={({ field }) => (
                          <div className="date-picker-container">
                            <DatePicker
                              selected={
                                field.value ? new Date(field.value) : null
                              }
                              onChange={(date) => field.onChange(date)}
                              dateFormat="MM-dd-yyyy"
                              placeholderText="MM-DD-YYYY"
                              minDate={minDate}
                              maxDate={maxDate}
                              filterDate={isWeekdayAndNotHoliday}
                              className={
                                errors.payoff_good_through_date
                                  ? "custom-date-picker error"
                                  : "custom-date-picker"
                              }
                              holidays={US_Holidays}
                            />

                            {errors.payoff_good_through_date && (
                              <small className="text-error">
                                {errors.payoff_good_through_date.message}
                              </small>
                            )}
                          </div>
                        )}
                      />
                    </div>
                    <div className="vf-group-for-payoff col-6">
                      <label>Demand Expiration Date</label>
                      <Controller
                        name="demand_expiration_date"
                        control={control}
                        render={({ field }) => (
                          <div className="date-picker-container">
                            <DatePicker
                              selected={
                                field.value ? new Date(field.value) : null
                              }
                              onChange={(date) => field.onChange(date)}
                              dateFormat="MM-dd-yyyy"
                              placeholderText="MM-DD-YYYY"
                              disabled
                              className={
                                errors.demand_expiration_date
                                  ? "custom-date-picker bg-grey error"
                                  : "custom-date-picker bg-grey"
                              }
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div className="vf-group-for-payoff col-6">
                      <SelectField
                        label={"CEMA"}
                        field={"cema"}
                        placeholder={"Select..."}
                        options={[
                          { label: "Yes", value: "Y" },
                          { label: "No", value: "N" },
                        ]}
                        watch={watch}
                        setValue={setValue}
                        control={control}
                        required={true}
                      />
                      {errors.cema && (
                        <small className="text-error mt-5">
                          {errors.cema.message}
                        </small>
                      )}
                    </div>
                  </div>
                )}

                {step === 1 && (
                  <>
                    <div className="vf-radio-card">
                      <h5 className="vf-radio-title text-start">
                        Do you know the Loan Account Number?
                      </h5>

                      <div className="vf-radio-options">
                        <label className="vf-radio-option">
                          <input
                            type="radio"
                            value="Y"
                            {...register("knows_loan_account")}
                          />
                          <span className="vf-radio-custom" />
                          <span className="vf-radio-label">Yes</span>
                        </label>

                        <label className="vf-radio-option">
                          <input
                            type="radio"
                            value="N"
                            {...register("knows_loan_account")}
                            onClick={() => setShowPropertySearch(true)}
                          />
                          <span className="vf-radio-custom" />
                          <span className="vf-radio-label">No</span>
                        </label>
                      </div>
                    </div>

                    {knows_loan_account === "Y" ? (
                      <div className="row">
                        <div className="vf-group-for-payoff col-12 text-start">
                          <label className="">Loan Account Number</label>

                          <div className={`input-with-action ${status || ""}`}>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter loan account number"
                              {...register("account_number")}
                            />

                            <LoadingButton
                              type="button"
                              className="btn btn-primary btn-sm btn-modern-outline validate-btn"
                              title={
                                loanNumberLoading ? "Validating..." : "Validate"
                              }
                              disabled={loanNumberLoading}
                              loading={loanNumberLoading}
                              onClick={validateLoanAccount}
                            />

                            {loanNumberStatus === "success" &&
                              !loanNumberLoading && (
                                <CheckCircleFill className="status-icon success" />
                              )}
                            {loanNumberStatus === "error" &&
                              !loanNumberLoading && (
                                <XCircleFill className="status-icon error" />
                              )}
                          </div>
                          {errors.account_number && (
                            <small className="text-error">
                              {errors.account_number.message}
                            </small>
                          )}
                        </div>
                        {isValidAccount && (
                          <div className="row text-start">
                            <div className="vf-group-for-payoff col-12">
                              <label>Property Address - Street</label>

                              <input
                                // {...register("property_street")}
                                {...register("masked_property_street")}
                                className={
                                  errors.property_street
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="123 Main Street"
                                disabled
                              />
                            </div>
                            <div className="vf-group-for-payoff col-4">
                              <label>City</label>
                              <input
                                {...register("property_city")}
                                className={
                                  errors.property_city
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="Los Angeles"
                                disabled
                              />
                            </div>
                            <div className="vf-group-for-payoff col-4">
                              <SelectField
                                label={"State"}
                                field={"property_state"}
                                placeholder={"Select..."}
                                options={states}
                                watch={watch}
                                setValue={setValue}
                                disable={true}
                                control={control}
                              />
                            </div>
                            <div className="vf-group-for-payoff col-4">
                              <label>Zip Code</label>
                              <input
                                {...register("property_zip")}
                                className={
                                  errors.property_zip
                                    ? "vf-input error"
                                    : "vf-input"
                                }
                                placeholder="90001"
                                disabled
                              />
                            </div>

                            {/* {errors?.["loan_property"]?.message?.length && (
                              <div className="vf-group-for-payoff col-12 text-center">
                                <p className="text-error">
                                  {errors?.["loan_property"]?.message + "!"}
                                </p>
                              </div>
                            )} */}
                          </div>
                        )}
                        {/* <div className="vf-group-for-payoff col-12 text-start">
                          <label>Additional Notes (Optional)</label>
                          <textarea
                            className="vf-textarea"
                            {...register("notes")}
                            placeholder="Enter any additional notes or comments..."
                          />
                        </div> */}
                        {/* {errors?.["loan_property"]?.message?.length && (
                          <div className="vf-group-for-payoff col-12">
                            <p className="text-error">
                              {errors?.["loan_property"]?.message + "!"}
                            </p>
                          </div>
                        )} */}
                      </div>
                    ) : (
                      knows_loan_account === "N" && (
                        <>
                          <button
                            className="w-100 btn btn-outline-primary btn-modern-outline px-5 py-4 d-flex justify-content-center align-items-center"
                            onClick={() => setShowPropertySearch(true)}
                            type="button"
                          >
                            <Search className="me-5" />
                            Search Property Address
                          </button>
                          {selectedProperty ? (
                            <PropertyCard
                              selectedProperty={selectedProperty}
                              setShowPropertySearch={setShowPropertySearch}
                              setValue={setValue}
                              setLoanStatus={setLoanStatus}
                            />
                          ) : null}
                          {noPropertyFound ? (
                            <ManualEntryCard
                              borrower_email={borrower_email}
                              remarks={remarks}
                              setShowPropertySearch={setShowPropertySearch}
                            />
                          ) : null}
                        </>
                      )
                    )}
                  </>
                )}

                {step === 2 && (
                  <div className="row text-start">
                    {/* <div className="vf-group-for-payoff col-6">
                      <label>Signature of Applicant</label>
                      <UseSignature
                        title={"Click to sign"}
                        field={"applicant_signature"}
                        register={register}
                        setValue={setValue}
                        watch={watch}
                        error={errors.applicant_signature}
                      />
                    </div> */}
                    <div className="vf-radio-box text-muted col-12">
                      <input
                        type="checkbox"
                        {...register("borrower_sign_available")}
                      />
                      <p>
                        Please upload the borrower’s authorization if available.
                        If the authorization is not provided, a notification
                        will be sent to the borrower requesting their signature
                        for the payoff request.
                      </p>
                    </div>
                    {display && (
                      <div className="vf-group-for-payoff col-12 mt-5">
                        <UseFormFileInput
                          title={"Borrower's Authorization"}
                          field={"borrower_signature"}
                          setValue={setValue}
                          error={errors?.borrower_signature?.message}
                          // isbase64={true}
                          accept={"application/pdf"}
                          dragAndDrop={true}
                          files={borrowerSignature}
                        />
                      </div>
                    )}
                  </div>
                )}

                {/* {step === 2 && (
                  <div className="p-5 m-5 bg-warning bg-opacity-10 text-start">
                    <p className="mb-0 small">
                      <strong>Note:</strong>{" "}
                      <span className="text-muted">
                        The confidentiality of the information you have
                        furnished will be preserved except where disclosure of
                        this information is required by applicable law. The form
                        is to be transmitted directly to the lender and is not
                        to be transmitted through the applicant or any other
                        party.
                      </span>
                    </p>
                  </div>
                )} */}
                {step === 3 && (
                  <ReviewInformationForPayoff
                    data={watch()}
                    onEditSection={(step) => setStep(step)}
                    isValidAccount={isValidAccount}
                  />
                )}
                {/* {step === 4 && (
                  <PaymentStep
                    method={method}
                    setMethod={setMethod}
                    submitFlag={submitFlag}
                    onSuccess={onSubmit}
                    data={watch()}
                    setStripeLoaded={setStripeLoaded}
                    setSubmitLoading={setSubmitLoading}
                    email={email}
                    validLoanNumber={validLoanNumber}
                    propertyAddress={propertyAddress}
                    invoiceID={invoiceID}
                    setInvoiceID={setInvoiceID}
                    paymentIntentId={paymentIntentId}
                    setPaymentIntentId={setPaymentIntentId}
                    vomNumber={vomNumber}
                    loanStatus={loanStatus}
                  />
                )} */}
              </div>
              {/* FOOTER */}
              <div className="vf-actions">
                <button
                  type="button"
                  className="btn btn-secondary border"
                  onClick={back}
                  disabled={step === 0}
                  style={
                    step === 0 ? { cursor: "not-allowed", color: "gray" } : null
                  }
                >
                  <ChevronLeft /> Previous
                </button>

                {step < 3 ? (
                  <button
                    type="button"
                    className="vf-primary-btn"
                    onClick={next}
                    disabled={
                      (step === 1 && knows_loan_account == null) ||
                      (step === 1 &&
                        knows_loan_account === "Y" &&
                        !isValidAccount) ||
                      (step === 1 &&
                        knows_loan_account === "N" &&
                        !selectedProperty &&
                        !borrower_email?.length) ||
                      loanNumberLoading
                    }
                    style={
                      (step === 1 && knows_loan_account == null) ||
                      (step === 1 &&
                        knows_loan_account === "Y" &&
                        !isValidAccount) ||
                      loanNumberLoading
                        ? { cursor: "not-allowed" }
                        : null
                    }
                    title={
                      ((step === 1 && knows_loan_account == null) ||
                        (step === 1 &&
                          knows_loan_account === "Y" &&
                          !isValidAccount)) &&
                      "Please provide a complete property address or validate a loan account number."
                    }
                  >
                    {step === 1 &&
                    (validBorrower || validLender) &&
                    !submitLoading ? (
                      "Request Payoff"
                    ) : step === 1 &&
                      (validBorrower || validLender) &&
                      submitLoading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Requesting Payoff
                      </>
                    ) : (
                      "Next Step →"
                    )}
                  </button>
                ) : (
                  // step === 3 ? (
                  //   <LoadingButton
                  //     type="submit"
                  //     className="btn btn-primary btn-md py-4 btn-modern-outline"
                  //     title={"Next Step →"}
                  //     disabled={submitLoading}
                  //     loading={submitLoading}
                  //     onClick={checkForDuplicate}
                  //   />

                  // ) :
                  <LoadingButton
                    type="submit"
                    className="btn btn-primary btn-md py-4 btn-modern-outline"
                    title={
                      <span>
                        <Send className="me-4" />
                        Submit Request
                      </span>
                    }
                    disabled={submitLoading}
                    loading={submitLoading}
                    onClick={handleSubmit((formData) =>
                      onSubmit(formData, false),
                    )}
                  />
                )}
              </div>
            </form>
          </div>
        </Card>
      </div>

      <InvalidModal
        show={showInvalidModal}
        setShow={setShowInvalidModal}
        message={invalidModalMessage}
        setValue={setValue}
        setStep={setStep}
      />
      <PropertyAddressModal
        show={showPropertySearch}
        setShow={setShowPropertySearch}
        states={states}
        selectedProperty={selectedProperty}
        setSelectedProperty={setSelectedProperty}
        noPropertyFound={noPropertyFound}
        setNoPropertyFound={setNoPropertyFound}
        setValueInMainForm={setValue}
        setValidLoanNumber={setValidLoanNumber}
        source="payoff"
        validateBorrower={validateBorrower}
        validateLender={validateLender}
        requestor_type={requestor_type}
      />
    </div>
  );
};

export default PayoffRequestForm;

const formatPhoneNumber = (value) => {
  // Remove everything except digits
  const digits = value.replace(/\D/g, "").slice(0, 10);

  const len = digits.length;

  if (len < 4) return digits;
  if (len < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const SelectField = ({
  label,
  field,
  placeholder,
  options,
  watch,
  setValue,
  disable = false,
  control,
  required=false
}) => {
  const value = options?.filter((data) => data.value === watch(field))[0];
  return (
    <>
      <label>
        {label} {required && <span className="text-danger">*</span>}
      </label>

      <Controller
        name={field}
        control={control}
        render={({ field: { onChange, onBlur, value, name, ref } }) => {
          const selectedOption =
            options?.find((option) => option.value === value) || null;

          return (
            <Select
              name={name}
              ref={ref}
              value={selectedOption}
              options={options}
              placeholder={placeholder}
              onChange={(selected) => {
                setValue(field, selected?.value ?? "", {
                  shouldValidate: true,
                  shouldDirty: true,
                  shouldTouch: true,
                });
              }}
              onBlur={onBlur}
              styles={customStyles}
              menuPosition="fixed"
              isDisabled={disable}
            />
          );
        }}
      />
    </>
  );
};

const InvalidModal = ({ show, setShow, message, setValue, setStep }) => {
  return (
    <PopupWrapper
      title={
        <h4 className="p-4 font-weight-bold text-bold">
          {" "}
          <ExclamationTriangleFill
            className="mt-2 me-2 pb-3"
            color="#dc3545"
            size={25}
          />
          Email address not recognized
        </h4>
      }
      extraClass="width-800"
      Component={
        <div>
          <p className="">{message}</p>
          <div className="text-end ">
            <Button
              text={"Proceed"}
              onClick={() => {
                setValue("requestor_type", "Other");
                setShow(false);
              }}
            />

            <button
              className={"btn btn-grey text-black ms-5"}
              onClick={() => {
                setStep(0);
                setShow(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      }
      toShow={show}
      // closeEventHandler={() => setShow(false)}
      backdrop="static"
      closeButton={false}
    />
  );
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "50px",
    minWidth: "250px",
    height: "30px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    minHeight: "50px",
    height: "30px",
  }),
  container: (base) => ({
    ...base,
    width: "100%",
    height: "30px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    position: "absolute",
  }),
};

const PropertyCard = ({
  selectedProperty,
  setShowPropertySearch,
  setValue,
  setLoanStatus,
}) => {
  useEffect(() => {
    if (selectedProperty !== null) {
      setValue("property_street", selectedProperty?.STREET);
      setValue("property_city", selectedProperty?.CITY);
      setValue("property_state", selectedProperty?.STATE);
      setValue("property_zip", selectedProperty?.ZIPCODE);
      setValue("account_number", selectedProperty?.ACCOUNT);
      // setValue("applicant_name", selectedProperty?.FULLNAME);
      setValue("account_name", selectedProperty?.FULLNAME);
      setValue("masked_applicant_name", selectedProperty?.MASKED_FULLNAME);
      // setValue("borrower_mailing_address", selectedProperty?.BORROWER_MAILING_ADDRESS);

      setLoanStatus(selectedProperty?.LOAN_STATUS);
    }
  }, [selectedProperty?.ACCOUNT, setValue]);

  return (
    <div className="property-selected-card text-start mt-5">
      <div className="card-header">
        <InfoCircle size={20} />
        <strong>Property Selected</strong>
      </div>

      <div className="card-body">
        <p className="text-muted">
          <strong>Address:</strong> {selectedProperty.STREET}
        </p>
        <p className="text-muted">
          <strong>City:</strong> {selectedProperty.CITY},{" "}
          {selectedProperty.STATE} {selectedProperty.ZIPCODE}
        </p>
        <p className="text-muted">
          <strong>Borrower:</strong> {selectedProperty.MASKED_FULLNAME}
        </p>
        <p className="text-muted">
          <strong>Loan #:</strong> {selectedProperty.MASKED_ACCOUNT}
        </p>

        <button
          className="link-btn"
          type="button"
          onClick={() => setShowPropertySearch(true)}
        >
          Change Selection
        </button>
      </div>
    </div>
  );
};

const ManualEntryCard = ({
  setShowPropertySearch,
  borrower_email,
  remarks,
}) => {
  return (
    <div className="property-selected-card-yellow text-start mt-5">
      <div className="card-header">
        <InfoCircle size={20} />
        <strong>Property Not Found - Manual Entry</strong>
      </div>

      <div className="card-body">
        <p className="text-muted">
          <strong>Borrower Email:</strong> {borrower_email}
        </p>
        <p className="text-muted">
          <strong>Remarks:</strong> {remarks}
        </p>

        <button
          className="link-btn"
          type="button"
          onClick={() => setShowPropertySearch(true)}
        >
          Search Again
        </button>
      </div>
    </div>
  );
};
